export interface CellState {
    selected: boolean;
    outOfRange: boolean;
    current: boolean;
}

export function cellStateClass({ selected, outOfRange, current }: CellState): string {
    if (selected) return 'bg-gray-900 text-white font-semibold';
    if (outOfRange) return 'text-gray-300 font-medium';
    if (current) return 'bg-yellow-50 text-gray-800 font-semibold ring-1 ring-yellow-400';
    return 'text-gray-800 hover:bg-gray-100 font-medium';
}
